var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20898 14.013V2.47969C1.20898 1.66073 1.87632 0.998474 2.70156 0.998474H10.7156C11.5378 0.998474 12.2082 1.66073 12.2082 2.47969V5.8442",
    stroke: "#2E3138 ",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2055 10.551V14.013C12.2055 14.829 11.5382 15.4943 10.7129 15.4943H7.68311",
    stroke: "#2E3138 ",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01144 17.7264L2.1951 16.5142C1.61415 16.328 1.20898 15.784 1.20898 15.1868V2.37324C1.20898 1.50699 2.04018 0.918639 2.88329 1.18473L6.69964 2.3969C7.28058 2.58316 7.68575 3.12716 7.68575 3.72437V16.5349C7.68575 17.4042 6.85456 17.9925 6.01144 17.7235V17.7264Z",
    stroke: "#2E3138 ",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9512 8.28333H17.9999",
    stroke: "#2E3138 ",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2202 5.5249L17.9998 8.28333L15.2202 11.0418",
    stroke: "#2E3138 ",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.e6a976ecfe81464149e35ac3338406e7.svg";
export { ForwardRef as ReactComponent };